import React, { useState } from "react";

import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import { Link } from "react-router-dom";
const SpeedDial = (props) => {
  const { data, onClick, active, onClose } = props;

  return (
    <div className={`speed-dial-secondary ${active ? "speed-dial-secondary-active" : ""}`}>
      <div className="button" onClick={onClick}>
        {active ? <MenuOpenRoundedIcon /> : <MenuOpenRoundedIcon />}
      </div>

      <div className="speed-dial-content" onClick={onClose}>
        <div className="container">
          {data.map((item) =>
            item.isVisible ? (
              <div
                key={item.name}
                className="item"
                onClick={() => {
                  const section = document.getElementById(item.name);
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                  onClick(item);
                }}
              >
                <p className="menu-text">{item.name}</p>
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

export default SpeedDial;
